import { Routes, Route } from "react-router-dom";
import AdminDoctorsList from "./AdminDoctorsList";
import AdminDoctorNew from "./AdminDoctorNew";
import AdminDoctorProfile from "./AdminDoctorProfile";

export default function AdminDoctorsRoutes() {
  return (
    <Routes>
      <Route index element={<AdminDoctorsList />} />
      <Route path="new" element={<AdminDoctorNew />} />
      <Route path=":doctorId" element={<AdminDoctorProfile />} />
    </Routes>
  );
}
